import { selector } from 'recoil';
import { onsaProductStatusListAtom } from '../atoms/onsaProductStatusListAtom';
import { type ProductStatus } from '../types/onsaTypes';
import { getCurrentProduct } from '../../utils/coverablesUtil';

export const getOnsaCurrentProductSelector = selector<ProductStatus>({
    key: 'getOnsaCurrentProduct',
    get: ({ get }) => {
        const coverableList = get(onsaProductStatusListAtom);

        return getCurrentProduct(coverableList);
    }
});
